import type {
  AllowedOrganisationProduct,
  AllowedOrganisationProductList,
  Permission,
  UserRole,
} from "./types/types";

export const allowedProducts: AllowedOrganisationProduct[] = [
  "apata",
  "ads",
  "programme-manager",
  "cts-apis",
  "cardlimits",
  "digitalwallets",
  "clicktopay",
  "eds",
  "issuer",
  "rdx",
  "scamdetect",
  "showpan",
  "showpanportal",
  "showencrypted",
  "ws",
  "universal",
  "credit",
  "sponsorguard",
  "ach",
  "agentic",
  "iam-only",
  "stablecoin",
];

export const productDescriptions: AllowedOrganisationProductList = {
  apata: "3D Secure (Apata)",
  ads: "Alias Directory Service",
  "programme-manager": "Program manager features",
  "cts-apis": "CTS APIs access",
  cardlimits: "Card limits details",
  digitalwallets: "Digital wallet features",
  clicktopay: "Click to pay features",
  eds: "EDS information",
  issuer: "Issuer related",
  rdx: "3D Secure (RDX)",
  scamdetect: "Scam detection",
  showpan: "Show PAN",
  showpanportal: "Show PAN Portal",
  showencrypted: "Show encrypted data",
  ws: "Web services",
  universal: "Universal product",
  credit: "Credit product",
  sponsorguard: "SponsorGuard product",
  ach: "ACH Debit",
  agentic: "Agentic Access",
  "iam-only": "IAM Only",
  stablecoin: "Stablecoin",
};

/**
 * These should be replaced with proper runtime values once the features are complete.
 */
export const PLACEHOLDER_ORGANISATION_ID =
  "64ead413-79b8-41a5-9307-063ce186a61a";
export const PLACEHOLDER_APPLICATION_ID =
  "37440899-ff11-4b84-bcbb-a80125e6b479";

export const ADMIN_KEY = "Organisation Admin";
export const ORGANISATION_MANAGER_KEY = "Organisation Manager";

export const UserStatus = {
  Active: "Active",
  Pending: "Pending",
  Inactive: "Inactive",
  Other: "Other",
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  owner: [
    "admin",
    "manage_users",
    "invite_users",
    "manage_oauth_clients",
    "manage_security",
    "view_analytics",
    "manage_billing",
    "manage_organization_settings",
    "view_audit_logs",
    "manage_integrations",
    "view_organization",
    "manage_organization",
  ],
  admin: [
    "manage_users",
    "invite_users",
    "manage_oauth_clients",
    "manage_security",
    "view_analytics",
    "manage_organization_settings",
    "view_audit_logs",
    "manage_integrations",
    "view_organization",
    "manage_organization",
  ],
  user: [
    "view_analytics",
    "manage_oauth_clients",
    "view_audit_logs",
    "view_organization",
  ],
  viewer: ["view_analytics", "view_audit_logs", "view_organization"],
  super_admin: [
    "admin",
    "manage_users",
    "invite_users",
    "manage_oauth_clients",
    "manage_security",
    "view_analytics",
    "manage_billing",
    "manage_organization_settings",
    "view_audit_logs",
    "manage_integrations",
    "view_organization",
    "manage_organization",
    "view_any_organization",
    "manage_any_organization",
  ],
};

export const ACCESS_INFO_OPTIONS = {
  NONE: "none",
  PM_ID: "pmId",
  ISSUER_ID: "issuerId",
  INTERNAL_ID: "internalId",
};
